import { render, staticRenderFns } from "./RingbaIntegration.vue?vue&type=template&id=f92f2bae&scoped=true"
import script from "./RingbaIntegration.vue?vue&type=script&lang=js"
export * from "./RingbaIntegration.vue?vue&type=script&lang=js"
import style0 from "./RingbaIntegration.vue?vue&type=style&index=0&id=f92f2bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92f2bae",
  null
  
)

export default component.exports